module.exports = {
    experties: [
        {
            image: "/illustrations/javaScript_frameworks.svg",
            description: "Adept in using popular javascript frameworks like ReactJS, VueJS, Angular, ExpressJS"
        },
        {
            image: "/illustrations/mobile_application.svg",
            description: "Capable of delivering the best quality native mobile apps built with React Native and Expo"
        },
        {
            image: "/illustrations/static_website.svg",
            description: "XD to HTML. Generate a pixel perfect UI from XD to give a smooth browsing experience"
        },
        {
            image: "/illustrations/responsive_websites.svg",
            description: "Develop responsive websites which will run smoothly on any device"
        }
    ],
    socialLinks: [
        {
            name: "linkedin",
            url: "https://in.linkedin.com/in/rishivedpathak",
            icon: "fab fa-linkedin-in"
        },
        {
            name: "github",
            url: "https://github.com/RishikeshVedpathak",
            icon: "fab fa-github"
        },
        {
            name: "dev-community",
            url: "https://dev.to/rishikeshvedpathak",
            icon: "fab fa-dev"
        },
        {
            name: "medium",
            url: "https://rishi-vedpathak.medium.com/",
            icon: "fab fa-medium-m"
        },
        {
            name: "twitter",
            url: "https://twitter.com/RishiVedpathak",
            icon: "fab fa-twitter"
        }
    ],
    recaptcha_key: '6LdetsIUAAAAAGTT7J80bo__5XrerYbXiW7cJfaj',
    googleAnalyticsID: 'UA-152628671-1'
}